import moment from "moment";
import { ILogEntry } from "motw_core/Entity/ILogEntry";
import Data from "./Data";
import UI from "./UI/UI";

export function Minimum(array: number[]): number {
    const minimum = Math.min.apply(null, array);
    return minimum;
}

export function Maximum(array: number[]): number {
    const minimum = Math.max.apply(null, array);
    return minimum;
}

const Maths = {
    GetLevelOnDate: (log: ILogEntry[], date: string) => {
        const totalKips = Maths.GetTotalKipsOnDate(log, date);
        const level = Data.GetLevelFromKips(totalKips);
        return level;
    },

    GetTotalKipsOnDate: (log: ILogEntry[], date: string) => {
        const totalKipsToDate = log
            .filter((item) =>
                moment(item.lastmodifiedtime).local().isSameOrBefore(date)
            )
            .map((item) => item.kips)
            .filter((value) => value > 0);

        if (!totalKipsToDate.length) return 0;
        return totalKipsToDate.reduce((a, b) => a + b);
    },
    ConvertHexToRgbA(hex: string, opacity: number) {
        if (!hex || !opacity) throw new Error("missing values!");
        var c: any;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split("");
            if (c.length == 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = "0x" + c.join("");
            return (
                "rgba(" +
                [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
                "," +
                opacity +
                ")"
            );
        }

        console.error(`Bad hex provided: '${hex}'`);
        return `rgba(1, 1, 1, 1)`;
    },

    GetSingleRandomNumber: (maxNumber: number) => {
        return Math.floor(Math.random() * maxNumber) + 1;
    },

    GetKipsBatchCount: (kips: string) => {
        const value = parseInt(kips);
        if (value === undefined) return false;
        if (value < 0) return false;
        var batches = Math.floor(value / 5);
        return batches;
    },

    GetPenaltyPercent: (driveValue: number) => {
        if (!driveValue || driveValue < 0)
            throw new Error("Cannot parse the drive value: " + driveValue);

        if (driveValue === 7) return 25;
        if (driveValue === 8) return 50;
        if (driveValue === 9) return 75;
        if (driveValue >= 10) return 100;

        return 0;
    },

    CalculatePenalty: (driveValue: number, kips: number) => {
        if (
            driveValue === undefined ||
            kips === undefined ||
            driveValue < 0 ||
            kips < 0
        ) {
            throw new Error(
                "Cannot parse the given data: driveValue -" +
                    driveValue +
                    ", kips - " +
                    kips
            );
        }
        var penaltyPercent = Maths.GetPenaltyPercent(driveValue);
        var penaltyKips = Math.ceil((penaltyPercent / 100) * kips);
        return penaltyKips;
    },

    GetRecentDriveValues: (data: ILogEntry[]) =>
        data.map((row) => {
            if (!data) throw new Error("No data supplied!");
            return {
                symbol: UI.GetEventCategory(row.entry),
                value: row.kips,
            };
        }),
};

export default Maths;
